import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} notificat a la teva zona",
  "alert.toast.escalation": "{hazard} proper ha escalat de gravetat",
  "alert.toast.inPath": "{hazard} avança en direcció a la teva ubicació",
  "alert.toast.allClear": "Situació normalitzada prop de {place}",
  "alert.toast.tap": "Obre per consultar els detalls i les mesures de seguretat",
  "alert.takeover.title": "{hazard} — cal actuar immediatament",
  "alert.takeover.details": "Consultar l'informe complet",
  "now.status.allClear": "Cap perill actiu.",
  "now.status.stayAware": "Manteniu la vigilància.",
  "now.status.sub.allClear": "Cap perill actiu dins del vostre radi de vigilància.",
  "now.activity.empty": "Sense activitat registrada a les proximitats.",
  "onboarding.promise.tagline": "Una xarxa comunitària d'alerta primerenca.",
  "onboarding.promise.continue": "Iniciar",
  "region.unsupported.title": "Ubicació fora de l'àrea de cobertura",
  "you.voice.intro": "Trieu el to amb què Beacon es comunica.",
};
